import {html, render} from 'lit-html';
import {until} from 'lit-html/directives/until';
import SuccessIcon from  '!svg-inline-loader!../assets/alert-icons/success.svg';
import ErrorIcon from  '!svg-inline-loader!../assets/alert-icons/danger.svg';
import WarningIcon from  '!svg-inline-loader!../assets/alert-icons/warning.svg';
import InfoIcon from  '!svg-inline-loader!../assets/alert-icons/info.svg';
const types = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  NOTIFICATION: 'notification'
};
const classes = {
  [types.SUCCESS]: 'success',
  [types.ERROR]: 'danger',
  [types.WARNING]: 'warning',
  [types.INFO]: 'info',
  [types.NOTIFICATION]: 'dark'
};

const alertIcons = {
  [types.SUCCESS]: SuccessIcon,
  [types.ERROR]: ErrorIcon,
  [types.WARNING]: WarningIcon,
  [types.INFO]: InfoIcon,
};

const noop = () => true;
const toasts = {};
const globalOptions = {
  timeout: 4000,
  type: types.NOTIFICATION,
  callback: noop,
  removeOnDismiss: true,
  animateClass: 'aofl-toast-toast-animate-enter'
};
let increment = 0;
const container = document.getElementById('toastr-container');

class Toast {
  constructor(id, content, title = '', options = globalOptions) {
    this.id = id;
    this.content = content;
    this.title = title;
    this.options = options;
    this.delay = options.timeout;
    this.timeout = null;
    this.timeoutStart = 0;
    this.active = false;
    this.element = document.createElement('div');
    this.element.id = id;
    this.element.classList.add('aofl-toast-toast', 'alert', 'alert-dismissible', 'shadow-sm', `alert-${classes[options.type]}`);
    this.show();
  }

  clickHandler = () => {
    if (this.options.callback(this)) {
      this.dismiss();
    }
  };

  handleAlertClick = () => {
    if (this.options.alertClick) {
      this.options.alertClick();
      this.dismiss();
    }
  };

  keyPressHandler = (e) => {
    if (e.key === 'Enter' || e.code === 'Space') {
      this.clickHandler();
    }
  }

  mouseenterHandler = () => {
    clearTimeout(this.timeout);
    this.delay = this.delay - (Date.now() - this.timeoutStart);
  };

  mouseoutHandler = () => {
    this.setTimeout();
  }

  transitionendHandler = () => {
    container.removeChild(this.element);
    this.element.removeEventListener('transitionend', this.transitionendHandler);
  };

  render() {
    return html`
      <div @click="${this.handleAlertClick}" class="${this.options.alertClick ? 'cursor-pointer': ''}" role="alert" aria-live="polite">
        <div class="d-flex flex-row">
          <div class="toast-icon">${html([alertIcons[this.options.type]])}</div>
          <div style="flex:1;">
            ${this.title !== '' ? html`
              <h4 class="alert-heading">${until(this.title)}</h4>
            ` : ''}
            ${until(this.content)}
          </div>
        </div>

      </div>
      <button class="close btn btn-link text-white" type="button" @keypress="${this.keyPressHandler}" @click="${this.clickHandler}">
        <span class="ai ai-close-icon"></span>
      </button>
    `;
  }

  dismiss() {
    if (this.active === false) return;
    this.active = false;
    this.element.removeEventListener('mouseenter', this.mouseenterHandler);
    this.element.removeEventListener('mouseleave', this.mouseoutHandler);

    this.element.addEventListener('transitionend', this.transitionendHandler);
    this.element.classList.remove(this.options.animateClass);
    if (this.options.removeOnDismiss) {
      Toast.remove(this);
    }
  }

  show() {
    if (this.active === true) return;
    this.active = true;
    this.delay = this.options.timeout;

    if (this.options.timeout > 0) {
      // Doing this so that we set focus to container for users to automatically go in when pressing tab
      container.setAttribute('tabIndex', '-1');
      container.focus();
      this.element.addEventListener('mouseenter', this.mouseenterHandler);
      this.element.addEventListener('mouseleave', this.mouseoutHandler);
      this.setTimeout();
    }

    render(this.render(), this.element);
    if (container.firstChild) {
      container.insertBefore(this.element, container.firstChild);
    } else {
      container.appendChild(this.element);
    }
    setTimeout(() => {
      this.element.classList.add(this.options.animateClass);
    });
  }

  setTimeout() {
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, this.delay);
    this.timeoutStart = Date.now();
  }

  static SUCCESS = types.SUCCESS;
  static ERROR = types.ERROR;
  static WARNING = types.WARNING;
  static INFO = types.INFO;
  static NOTIFICATION = types.NOTIFICATION;

  static dismissAll() {
    for (const key in toasts) {
      if (!toasts.hasOwnProperty(key)) continue;
      toasts[key].dismiss();
    }
  }
  static success(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options, {
      type: Toast.SUCCESS
    });
    return Toast.show(content, title, _options);
  }
  static error(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options, {
      type: Toast.ERROR
    });
    return Toast.show(content, title, _options);
  }
  static warning(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options, {
      type: Toast.WARNING
    });
    return Toast.show(content, title, _options);
  }
  static info(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options, {
      type: Toast.INFO
    });
    return Toast.show(content, title, _options);
  }
  static notification(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options, {
      type: Toast.NOTIFICATION
    });
    return Toast.show(content, title, _options);
  }

  static show(content, title = '', options = globalOptions) {
    const _options = Object.assign({}, globalOptions, options);
    const id = 'toast-' + (++increment);
    toasts[id] = new Toast(id, content, title, _options);
    return toasts[id];
  }

  static remove(toast) {
    if (typeof toasts[toast.id] !== 'undefined') {
      toasts[toast.id].dismiss();
      delete toasts[toast.id];
    }
  }
}

export {
  Toast
};
